import React from "react";
import { Link } from "react-router-dom";

const About = () => {

const aboutInfo={
  id:1,
  img:`https://raw.githubusercontent.com/wdridoy11/web-icon/main/Profile.png`,
  description:`I’m Ridoy Sharif. I was born in Rangpur district, Mithapukur Upazila. I’m a Full Stack Web Developer & WordPress Expert. I have completed 100+ website design. My design is pixel perfect and clean coding. I know how to make a responsive and user-friendly website. I am totally responsible for your work. My goal is to satisfy my clients with my work. I like to learn, I like to use my creativity. I love to work with clients from all over the world. Are you looking for a best quality website design for you? If you need a clean and modern interface for your website. Contact me now to make your dream website design. My skills...`
}

  return <div>
          <div className="bg-[#0E1629] py-20">
              <div className="container">
                <div className="grid items-center md:grid-cols-2 gap-10">
                    <div>
                        <img className="border border-[#2A3343] rounded-lg mx-auto md:mx-0 mb-5 md:mb-0" src={aboutInfo.img} alt="About img" />
                    </div>
                    <div>
                        <h1 className='text-5xl font-medium text-[#22d3ee] mb-5'>About Me</h1>
                        <p className="text-lg mb-2 text-white">Hi!</p>
                        <p className="text-lg text-white">{aboutInfo.description}</p>
                        <Link to={'/about'} className="text-white btn bg-transparent border-2 border-[#22d3ee] px-10 rounded-full mt-7 hover:bg-[#22d3ee] hover:text-white duration-500">Read More</Link>
                    </div>
                </div>
            </div>
        </div>
  </div>;
};

export default About;
